import octes8h_0 from './octes8h_0.svg';
import octes8h_1 from './octes8h_1.svg';
import octes8h_2 from './octes8h_2.svg';
import octes8h_3 from './octes8h_3.svg';
import octes8h_4 from './octes8h_4.svg';
import octes8h_5 from './octes8h_5.svg';
import octes8h_6 from './octes8h_6.svg';
import octes8h_7 from './octes8h_7.svg';
import octes8h_8 from './octes8h_8.svg';

export default {
    octes8h_0,
    octes8h_1,
    octes8h_2,
    octes8h_3,
    octes8h_4,
    octes8h_5,
    octes8h_6,
    octes8h_7,
    octes8h_8
};



// WEBPACK FOOTER //
// ./src/images/octes/index.js